/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * DTO for updating an appointment location
 * @export
 * @interface UpdateAppointmentLocation
 */
export interface UpdateAppointmentLocation {
    /**
     * Unique identifier of the waiting room.
     * @type {string}
     * @memberof UpdateAppointmentLocation
     */
    roomId?: string;
    /**
     * name of a waiting room that isn't currently registered
     * @type {string}
     * @memberof UpdateAppointmentLocation
     */
    customRoomName?: string;
}

/**
 * Check if a given object implements the UpdateAppointmentLocation interface.
 */
export function instanceOfUpdateAppointmentLocation(value: object): value is UpdateAppointmentLocation {
    return true;
}

export function UpdateAppointmentLocationFromJSON(json: any): UpdateAppointmentLocation {
    return UpdateAppointmentLocationFromJSONTyped(json, false);
}

export function UpdateAppointmentLocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAppointmentLocation {
    if (json == null) {
        return json;
    }
    return {
        
        'roomId': json['roomId'] == null ? undefined : json['roomId'],
        'customRoomName': json['customRoomName'] == null ? undefined : json['customRoomName'],
    };
}

export function UpdateAppointmentLocationToJSON(json: any): UpdateAppointmentLocation {
    return UpdateAppointmentLocationToJSONTyped(json, false);
}

export function UpdateAppointmentLocationToJSONTyped(value?: UpdateAppointmentLocation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'roomId': value['roomId'],
        'customRoomName': value['customRoomName'],
    };
}

